<script setup>
import PulsingSubtitle from '@components/global/PulsingSubtitle.vue'
import Calendar from '@components/global/Calendar.vue'

defineProps(['data'])
</script>

<template>
	<section class="py-10 md:py-20">
		<div class="container">
			<div class="flex flex-col gap-8 md:gap-10">
				<div v-if="data.eyebrow || data.title" class="flex flex-col items-start gap-6 md:w-2/3 md:gap-8">
					<PulsingSubtitle v-if="data.eyebrow">{{ data.eyebrow }}</PulsingSubtitle>
					<h2 v-if="data.title">{{ data.title }}</h2>
				</div>

				<Calendar :src="data.src" />
			</div>
		</div>
	</section>
</template>
